import type { Confidence } from "../api/types";

export const confidenceColor = (c: Confidence): string => {
  if (c === "high") return "#4ade80";
  if (c === "medium") return "#fbbf24";
  return "#ef4444";
};

// Color a node by its hop depth from the seed match. Seed = bright flame, fading
// outward to match the void background.
export const depthColor = (depth: number): string => {
  const palette = [
    "#C084FC", // depth 0 — bright flame
    "#A855F7",
    "#7C3AED",
    "#5B21B6",
    "#3B1078",
  ];
  const idx = Math.min(Math.max(depth, 0), palette.length - 1);
  return palette[idx];
};

export const truncate = (s: string, n: number): string =>
  s.length > n ? s.slice(0, n - 1) + "…" : s;

export const formatPercent = (n: number): string =>
  `${Math.round(Math.max(0, Math.min(1, n)) * 100)}%`;
